import { TitleColor } from '..';
import Text from '../Text';

const Education2024 = () => (
  <>
    <TitleColor text="Kurser 2024" smallTitle />
    <Text>
      <b>Racekendskab til Professionel AdfærdsInstruktør</b>
      <br />6 måneders efteruddannelse hos Lone Enghave:
      <br />
      <i>
        Hundens historie og racernes udvikling gennem tiden. Racernes oprindelige arbejdsopgaver,
        brugsformål og adfærdskarakteristika.
      </i>
    </Text>
    <Text>
      <b>Irene Jarnved og Smertedyrlægen Maria Søndergaard</b>
      <br />
      Kursus den 7-8. februar: Hundens afvigende adfærd - er den smerterelateret?
    </Text>
  </>
);

export default Education2024;
